import * as Sentry from "@sentry/vue";
import Logger from "@/services/logger";

const hasValue = (value) =>
  value !== undefined && value !== null && String(value).length > 0;

const FLOW_STEPS = {
  INITIAL_CIT: "initial_cit",
  RETRY_CIT: "retry_cit",
  CROSSSELL: "crosssell",
  UPSELL: "upsell",
  WAITING_POLL: "waiting_poll",
  REDIRECT: "redirect",
};

const BUG_IDS = {
  PARAM_PLUS_STALE: "param_plus_stale",
  IFRAME_LOG_UNDEFINED: "iframe_log_undefined",
  CROSSSELL_NO_MIT: "crosssell_no_mit",
};

function applyScope(scope, { level, tags, context, fingerprint }) {
  if (level) scope.setLevel(level);
  scope.setTag("module", "vanguard_checkout_payment");
  scope.setTag("page_url", window.location.href);

  Object.entries(tags).forEach(([key, value]) => {
    if (hasValue(value)) {
      scope.setTag(key, String(value));
    }
  });

  if (Object.keys(context).length > 0) {
    scope.setContext("payment_flow", {
      ...context,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  }

  if (Array.isArray(fingerprint) && fingerprint.length > 0) {
    scope.setFingerprint(fingerprint);
  }
}

export { FLOW_STEPS, BUG_IDS };

export default class PaymentMonitoring {
  static trackFunnelEvent(eventName, { tags = {}, context = {} } = {}) {
    try {
      Logger.log(eventName, {
        module: "vanguard_checkout_payment",
        pageUrl: window.location.href,
        tags,
        context,
      });
    } catch (error) {
      console.error("Failed to log funnel event", error);
    }
  }

  static captureMessage(
    eventName,
    { level = "warning", tags = {}, context = {}, fingerprint = [] } = {},
  ) {
    try {
      Sentry.withScope((scope) => {
        applyScope(scope, { level, tags, context, fingerprint });
        Sentry.captureMessage(eventName);
      });
    } catch (error) {
      console.error("Failed to send Sentry message", error);
    }
  }

  static captureException(
    error,
    { tags = {}, context = {}, fingerprint = [] } = {},
  ) {
    try {
      Sentry.withScope((scope) => {
        applyScope(scope, { tags, context, fingerprint });
        Sentry.captureException(error);
      });
    } catch (sentryError) {
      console.error("Failed to send Sentry exception", sentryError);
    }
  }
}
